import { IWWPartners } from 'legacy/lut/classes/models/partner360/IWWPartners'

import { IColumn } from 'core-components/library/list/types'
import { CircularProgress } from 'shared/components/circularProgress'

import { TRANSLATION_KEYS } from '../../../../../translations/TRANSLATION_KEYS'

export const extraColumns: IColumn[] = [
  {
    field: 'GeoRegion',
    title: TRANSLATION_KEYS.columnGeoRegion,
    priority: 3,
  },
  {
    field: 'PartnerType',
    title: TRANSLATION_KEYS.columnPartnerType,
    priority: 5,
  },
  {
    field: 'RTM',
    title: TRANSLATION_KEYS.columnRTM,
    priority: 5,
  },
  {
    field: 'SOBCategory',
    title: TRANSLATION_KEYS.columnSOBCategory,
    priority: 5,
  },
]

export const globalBaseColumns = [
  {
    field: 'PartnerID',
    title: TRANSLATION_KEYS.columnPartnerId,
    priority: 1,
  },
  {
    field: 'CommunicationName',
    title: TRANSLATION_KEYS.columnPartnerName,
    priority: 3,
  },
  {
    field: 'GeoRegion',
    title: TRANSLATION_KEYS.columnGeoRegion,
    priority: 4,
  },
  {
    field: 'PartnerType',
    title: TRANSLATION_KEYS.columnPartnerType,
    priority: 5,
  },
  {
    field: 'RTM',
    title: TRANSLATION_KEYS.columnRTM,
    priority: 5,
  },
  {
    field: `Plan360Completeness`,
    title: TRANSLATION_KEYS.columnCompletion,
    priority: 6,
    renderFunction: (item: IWWPartners) => {
      return (
        <CircularProgress
          percent={Number(item.Plan360Completeness)}
          radius={20}
          isShowCompletedIcon={Boolean(item.IsAcknowledged)}
        />
      )
    },
  },
]
